(() => {
  const initialize = () => {
    document.querySelectorAll('[data-am-header]').forEach(header => {
      if (header.dataset.initialized) return;
      header.dataset.initialized = 'true';
      const disclosures = [...header.querySelectorAll('[data-am-disclosure]')];
      const close = (item, focus = false) => {
        item.open = false;
        item.querySelector('summary').setAttribute('aria-expanded', 'false');
        if (focus) item.querySelector('summary').focus();
      };
      disclosures.forEach(item => {
        const summary = item.querySelector('summary');
        summary.setAttribute('aria-expanded', String(item.open));
        item.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(item.open));
          if (item.open) disclosures.filter(other => other !== item).forEach(other => close(other));
        });
        item.querySelector('[data-am-close]').addEventListener('click', () => close(item, true));
        item.addEventListener('keydown', event => {
          if (event.key === 'Escape' && item.open) {
            event.preventDefault();
            event.stopPropagation();
            close(item, true);
          }
        });
      });
      header.addEventListener('focusout', event => {
        if (event.relatedTarget && !header.contains(event.relatedTarget)) disclosures.forEach(item => close(item));
        else if (event.relatedTarget) disclosures.forEach(item => {
          if (item.open && !item.contains(event.relatedTarget)) close(item);
        });
      });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) disclosures.forEach(item => close(item));
      });
      const mobile = header.querySelector('.am-mobile-nav');
      const mobileQuery = window.matchMedia('(max-width:749px)');
      mobile.open = !mobileQuery.matches;
      mobileQuery.addEventListener('change', () => {
        mobile.open = !mobileQuery.matches;
        disclosures.forEach(item => close(item));
      });
      mobile.addEventListener('keydown', event => {
        if (event.key === 'Escape' && mobile.open && window.matchMedia('(max-width:749px)').matches) {
          mobile.open = false;
          mobile.querySelector('summary').focus();
        }
      });
      window.addEventListener('pageshow', event => {
        if (event.persisted) disclosures.forEach(item => close(item));
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
